// extracted by mini-css-extract-plugin
export default {"header":"BaseContainer_header__CV6-8","search":"BaseContainer_search__jNRYa"};